import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchSavedSearches } from '../../redux/slices/savedSearchesSlice/savedSearchesSlice';
import SavedSearchesTable from './SavedSearchesTable';

function ManageSearchLayout({ searchType }) {
  const dispatch = useDispatch();
  dispatch(fetchSavedSearches(searchType));
  return (
    <div>
      <h2>Manage Searches</h2>
      <hr className="mb-5 mt-0" />
      <div className="row">
        <div className="col">
          <SavedSearchesTable searchType={searchType} />
        </div>
      </div>
    </div>
  );
}

ManageSearchLayout.propTypes = {
  searchType: PropTypes.oneOf([0, 1, 2]).isRequired,
};

export default ManageSearchLayout;
